// src/app/utils/rx-chain.ts
import {mergeMap, Observable} from "rxjs";

export class RxChain<T> {
  constructor(private obs$: Observable<T>) {}

  /** inicia o chain a partir de um Observable */
  static start<T>(obs$: Observable<T>): RxChain<T> {
    return new RxChain(obs$);
  }

  /**
   * adiciona um próximo estágio,
   * onde fn recebe o valor anterior e devolve um Observable<U>
   */
  next<U>(fn: (value: T) => Observable<U>): RxChain<U> {
    const next$ = this.obs$.pipe(mergeMap(fn));
    return new RxChain(next$);
  }

  /** expõe o Observable final para subscribe */
  subscribe(
    next: (value: T) => void,
    error?: (err: any) => void,
    complete?: () => void
  ) {
    return this.obs$.subscribe(next, error, complete);
  }

  /** se quiser sempre usar o subscribe do RxJS “puro” */
  toObservable(): Observable<T> {
    return this.obs$;
  }
}
